<div class="main-body">
  <div class="example-container">
    <div class="header-class pb-1 row w-100">
      <div class="custom_heading1 col p-0">
        <span>Master Questions</span>
      </div>
      <!-- <div class="container mx-auto mt-3">
        <input class="search-box" id="search" matInput [(ngModel)]="filterValue" (ngModelChange)="applyFilter()"
          type="text" placeholder="Search...">
        <ul class="drop"></ul>
      </div> -->
      <!-- <div class=" quick-link col p-0">
        <button class="custom_button" (click)="addNewRow()">+ Add Row</button>
      </div> -->
      <div class=" quick-link col p-0">
        <button class="custom_button" (click)="openDialog()">+ Add New Question</button>
      </div>
    </div>
  </div>
  <div class="table-title w-100">
    <span>List of Categories</span>
    <!-- <div class="quick-link col p-0">
      <button class="custom_button" (click)="openDialog()">+ Add New Category</button>
    </div> -->
    <div class="quick-link col p-0">
      <button class="icon-button" title="Delete Category" (click)="openDeleteDialog()">
        <i class="fa fa-trash"F></i>
      </button>
      <button class="icon-button" title="Add New Category" (click)="openAddDialog()">
        <i class="fa fa-plus"></i> 
      </button>
    </div>
  </div>
  <div class="table-container">
    <div class="question-table">
      <div *ngFor="let category of categories">
        <div class="question-container">
          <mat-accordion>
            <mat-expansion-panel class="mb-2" (opened)="getQuestions(category.id)">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  {{category.description}}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <mat-table [dataSource]="dataSourceMap.get(category.id)" matSort class="p-0 w-100 col-12">
                <ng-container matColumnDef="QuestionID">
                  <mat-header-cell *matHeaderCellDef mat-sort-header class="id"> ID </mat-header-cell>
                  <mat-cell *matCellDef="let row" class="id">
                    <input type="text" [(ngModel)]="row.QuestionID" class="data-entry-inp w-100 border-0">
                  </mat-cell>
                </ng-container>
              
                <!-- <ng-container matColumnDef="Technology">
                  <mat-header-cell *matHeaderCellDef mat-sort-header class="Technology"> Technology </mat-header-cell>
                  <mat-cell *matCellDef="let row" class="Technology">
                    <ng-container *ngIf="row.isEditMode; else textMode">
                      <mat-select [(ngModel)]="row.TechnologyId" class="data-entry-inp w-100 border-0">
                        <mat-option *ngFor="let technology of technologies" [value]="technology.id">
                          {{ technology.description }}
                        </mat-option>
                      </mat-select>
                    </ng-container>
                    <ng-template #textMode>
                      <span>{{ row.Technology }}</span>
                    </ng-template>
                  </mat-cell>
                </ng-container> -->
                <ng-container matColumnDef="SubCategoryName">
                  <mat-header-cell *matHeaderCellDef mat-sort-header class="categoryName"> SubCategoryName </mat-header-cell>
                  <mat-cell *matCellDef="let row" class="categoryName">
                    <ng-container *ngIf="row.isEditMode; else textMode">
                      <mat-select [(ngModel)]="row.SubcategoryId" class="data-entry-inp w-100 border-0">
                        <mat-option *ngFor="let subcategory of subCategories" [value]="subcategory.id">
                          {{ subcategory.description }}
                        </mat-option>
                      </mat-select>
                    </ng-container>
                    <ng-template #textMode>
                      <span>{{ row.SubCategoryName }}</span>
                    </ng-template>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Question">
                  <mat-header-cell *matHeaderCellDef mat-sort-header class="question"> Question </mat-header-cell>
                  <mat-cell *matCellDef="let row" class="question">
                    <input type="text" [disabled]="!row.isEditMode" [(ngModel)]="row.Question" class="w-100 border-0">
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Weightage">
                  <mat-header-cell *matHeaderCellDef mat-sort-header class="Weightage"> Weightage </mat-header-cell>
                  <mat-cell *matCellDef="let row" class="Weightage">
                    <input type="text" [disabled]="!row.isEditMode" [(ngModel)]="row.Weightage" class="w-100 border-0">
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <mat-header-cell *matHeaderCellDef class="Actions"> Actions </mat-header-cell>
                  <mat-cell *matCellDef="let row" class="Actions">
                    <button *ngIf="!row.isEditMode" class="custom_button1" (click)="editRow(row , category.id)">
                      Edit
                    </button>
                    <button *ngIf="row.isEditMode" class="custom_button1" (click)="Save(row, category.id)">Save</button>
                    <button class="custom_button1" (click)="deleteRow(row.QuestionMappingId, category.id)">
                      Delete
                    </button>
                    
                  </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns" class="table-header"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
              </mat-table>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <div class="modal-backdrop" *ngIf="displayStyle === 'block'" (click)="closeModal()"></div> -->